export function isValidRecordId(id: number | undefined): id is number {
  return id !== undefined && Number.isSafeInteger(id) && id > 0;
}

export function parseRecordId(value: string | undefined): number {
  return value && /^\d+$/.test(value) ? Number(value) : NaN;
}
